/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {useSelector} from 'react-redux';
import {permissionSelectedSelector} from '@ion/applications/src/store/selectors/login';
import {Entity, Link} from '@ion/core/src/types/entities';
import {Operation} from '@ion/core/src/types/general';

export const hasPermission = (permissions: Link[], permission: string): boolean => {
  const permissionsMap = getPermissionMap(permissions);
  return !!permissionsMap?.[permission];
};

export const getPermissionMap = (permissions: Link[]) => {
  const permissionsMap = {};
  permissions?.forEach((permission) => {
    permissionsMap[permission?.title] = true;
  });
  return permissionsMap;
};

// [ION-APP TODO]: This hook has been deprecated and clients will
// need to be updated to use the new `useHasRolePermission` hook instead.

/**
 * @deprecated This hook has been deprecated and is not to be used by new implementations,
 *             rather, the `useHasRolePermission` hook should be used exclusively instead
 *             as it provides a unified implementation which is based on the application's
 *             underlying Features API - which is always to serve as the single source of
 *             truth for all Role, Features, and Permissions access. Additionally, the
 *             `useHasRolePermission` has been optimized to execute significantly more
 *             efficiently than the deprecated `useHasPermission`.
 */
export const useHasPermission = (entity: Entity | string, op: Operation | string = Operation.Create): boolean => {
  const permissions = useSelector(permissionSelectedSelector);
  const permission  = entity?.toLowerCase().concat('-', op);
  return hasPermission(permissions, permission);
};

export default useHasPermission;
